import { render, staticRenderFns } from "./RightNavDrawer.vue?vue&type=template&id=39d8d5cc&scoped=true&"
import script from "./RightNavDrawer.vue?vue&type=script&lang=js&"
export * from "./RightNavDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d8d5cc",
  null
  
)

export default component.exports